module.exports = __webpack_public_path__ + "static/media/icon-upload.ae9cd7e7.svg";